module.exports = __webpack_public_path__ + "static/media/A7.820bf7de.mp3";